export default "__VITE_ASSET__ClwWzTEB__"